var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('e-form',{ref:"form",attrs:{"size":"small","label-width":"150px"}},[_c('template',{slot:"item"},[_c('el-form-item',{attrs:{"label":"打印机","label-width":"150px"}},[_c('printer',{attrs:{"template-id":this.templateId}})],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2791209e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/select-printer.vue
// module id = null
// module chunks = 